import { FleekError } from './FleekError';

type PrivateGateway = {
  id?: string;
  name?: string;
};

type PrivateGatewayAlreadyExistsErrorOptions = {
  privateGateway: PrivateGateway;
};

export class PrivateGatewayAlreadyExistsError extends FleekError<PrivateGatewayAlreadyExistsErrorOptions> {
  public name = 'PrivateGatewayAlreadyExistsError';

  toString = () => `Private gateway already exists. Please choose different name for the private gateway.`;
}
